
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 460 957","version":"1.1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('linearGradient',{attrs:{"x1":"48.7286559%","y1":"69.8548644%","x2":"48.5423917%","y2":"94.4974511%","id":"linearGradient-1"}},[_c('stop',{attrs:{"stop-color":"#5059E3","offset":"0%"}}),_c('stop',{attrs:{"stop-color":"#7E57D2","offset":"100%"}})])]),_c('g',{attrs:{"id":"Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"blob-header-mobile","fill":"url(#linearGradient-1)","fill-rule":"nonzero"}},[_c('path',{attrs:{"d":"M0,868 C32.6666667,894 62.5,907 89.5,907 C124.773842,907 162,894 246,880 C293.633202,872.061133 347.268723,896.393366 401,928 C423.666667,941.333333 443.333333,951 460,957 L460,0 L0,0 L0,868 Z","id":"Path"}})])])])
          )
        }
      }
    